import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_PLEITOS_URL}${process.env.VUE_APP_API_PATH}`

export default {
    listarPleitos() {
        return axiosJwt
            .get(`${api}/pleitos/financeiro`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPleitoPorId(id) {
        return axiosJwt
            .get(`${api}/pleitos/financeiro/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluir(id) {
        return axiosJwt
            .delete(`${api}/pleitos/financeiro/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterGestores() {
        return axiosJwt
            .get(`${api}/pleitos/financeiro/gestores`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterFornecedor(cnpjcpf) {
        return axiosJwt
            .get(`${api}/pleitos/financeiro/obterfornecedor/${cnpjcpf}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserir(pleito) {
        return axiosJwt
            .post(`${api}/pleitos/financeiro`, pleito)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    alterar(pleito) {
        return axiosJwt
            .put(`${api}/pleitos/financeiro`, pleito)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterDocumentosPleito(id) {
        return axiosJwt
            .get(`${api}/pleitos/financeiro/documentos/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirDocumentoPleito(id) {
        return axiosJwt
            .delete(`${api}/pleitos/financeiro/documentos/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    downloadDocumentoPleito(pleitoId, idDocumento) {
        return axiosJwt
            .get(
                `${api}/pleitos/financeiro/downloaddocumento/${pleitoId}/${idDocumento}`,
                { responseType: 'blob' }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirDocumentoPleito(documento) {
        const formData = new FormData()
        formData.append('pleitoId', documento.pleitoId)
        formData.append('vcNomeArquivo', documento.vcNomeArquivo)
        formData.append('arquivo', documento.arquivo)
        formData.append('descricaoArquivo', documento.descricaoArquivo)
        return axiosJwt
            .post(`${api}/pleitos/financeiro/inserirdocumento`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterUnidades() {
        return axiosJwt
            .get(`${api}/pleitos/financeiro/unidades`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterNaturezas() {
        return axiosJwt
            .get(`${api}/pleitos/financeiro/naturezas`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAcoes(pleitoId) {
        return axiosJwt
            .get(`${api}/pleitos/financeiro/${pleitoId}/acoes`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirAcao(acao) {
        return axiosJwt
            .post(`${api}/pleitos/financeiro/${acao.pleitoId}/acoes`, acao)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirAcao(pleitoId, acaoId) {
        return axiosJwt
            .delete(`${api}/pleitos/financeiro/${pleitoId}/acoes/${acaoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterMetasPorAcao(acaoId) {
        return axiosJwt
            .get(`${api}/pleitos/financeiro/acoes/${acaoId}/metas`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirMeta(meta) {
        return axiosJwt
            .post(`${api}/pleitos/financeiro/acoes/${meta.acaoId}/metas`, meta)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirMeta(metaId, acaoId) {
        return axiosJwt
            .delete(`${api}/pleitos/financeiro/acoes/${acaoId}/metas/${metaId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTiposInstrumento() {
        return axiosJwt
            .get(`${api}/pleitos/financeiro/tiposinstrumento`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterDespesasParceiro(pleitoId) {
        return axiosJwt
            .get(`${api}/pleitos/financeiro/${pleitoId}/despesasparceiro`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirDespesaParceiro(despesa) {
        return axiosJwt
            .post(
                `${api}/pleitos/financeiro/${despesa.pleitoId}/despesasparceiro`,
                despesa
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirDespesaParceiro(pleitoId, despesaParceiroId) {
        return axiosJwt
            .delete(
                `${api}/pleitos/financeiro/${pleitoId}/despesasparceiro/${despesaParceiroId}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterDespesasSebrae(pleitoId) {
        return axiosJwt
            .get(`${api}/pleitos/financeiro/${pleitoId}/despesassebrae`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirDespesaSebrae(despesa) {
        return axiosJwt
            .post(
                `${api}/pleitos/financeiro/${despesa.pleitoId}/despesassebrae`,
                despesa
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirDespesaSebrae(pleitoId, despesaSebraeId) {
        return axiosJwt
            .delete(
                `${api}/pleitos/financeiro/${pleitoId}/despesassebrae/${despesaSebraeId}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterCronogramasDesembolsoSebrae(pleitoId) {
        return axiosJwt
            .get(
                `${api}/pleitos/financeiro/${pleitoId}/cronogramasdesembolsosebrae`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirCronogramaDesembolsoSebrae(cronogramaDesembolsoSebrae) {
        return axiosJwt
            .post(
                `${api}/pleitos/financeiro/${cronogramaDesembolsoSebrae.pleitoId}/cronogramasdesembolsosebrae`,
                cronogramaDesembolsoSebrae
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirDespesaSebrae(pleitoId, cronogramaDesembolsoSebraeId) {
        return axiosJwt
            .delete(
                `${api}/pleitos/financeiro/${pleitoId}/cronogramasdesembolsosebrae/${cronogramaDesembolsoSebraeId}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterCronogramasDesembolsoSebrae(pleitoId) {
        return axiosJwt
            .get(
                `${api}/pleitos/financeiro/${pleitoId}/cronogramasdesembolsosebrae`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirCronogramaDesembolsoSebrae(cronogramaDesembolsoSebrae) {
        return axiosJwt
            .post(
                `${api}/pleitos/financeiro/${cronogramaDesembolsoSebrae.pleitoId}/cronogramasdesembolsosebrae`,
                cronogramaDesembolsoSebrae
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirCronogramaDesembolsoSebrae(pleitoId, cronogramaDesembolsoSebraeId) {
        return axiosJwt
            .delete(
                `${api}/pleitos/financeiro/${pleitoId}/cronogramasdesembolsosebrae/${cronogramaDesembolsoSebraeId}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterCronogramasDesembolsoParceiro(pleitoId) {
        return axiosJwt
            .get(
                `${api}/pleitos/financeiro/${pleitoId}/cronogramasdesembolsoparceiro`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirCronogramaDesembolsoParceiro(cronogramaDesembolsoParceiro) {
        return axiosJwt
            .post(
                `${api}/pleitos/financeiro/${cronogramaDesembolsoParceiro.pleitoId}/cronogramasdesembolsoparceiro`,
                cronogramaDesembolsoParceiro
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirCronogramaDesembolsoParceiro(
        pleitoId,
        cronogramaDesembolsoParceiroId
    ) {
        return axiosJwt
            .delete(
                `${api}/pleitos/financeiro/${pleitoId}/cronogramasdesembolsoparceiro/${cronogramaDesembolsoParceiroId}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterCronogramasFisicos(pleitoId) {
        return axiosJwt
            .get(`${api}/pleitos/financeiro/${pleitoId}/cronogramasfisicos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirCronogramaFisico(cronogramaFisico) {
        return axiosJwt
            .post(
                `${api}/pleitos/financeiro/${cronogramaFisico.pleitoId}/cronogramasfisicos`,
                cronogramaFisico
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirCronogramaFisico(pleitoId, cronogramaFisicoId) {
        return axiosJwt
        .delete(`${api}/pleitos/financeiro/${pleitoId}/cronogramasfisicos/${cronogramaFisicoId}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorHandler(error)
        })
    },

    verificarAdimplenciaProponente(pleitoId) {
        return axiosJwt
            .get(`${api}/pleitos/financeiro/${pleitoId}/verificaradimplencia`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterParecerFinanceiro(pleitoId){
        return axiosJwt
            .get(`${api}/pleitos/financeiro/${pleitoId}/parecerfinanceiro`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirParecerFinanceiro(parecerFinanceiro) {
        return axiosJwt
            .post(`${api}/pleitos/financeiro/${parecerFinanceiro.pleitoId}/parecerfinanceiro`, parecerFinanceiro)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    
    excluirParecerFinanceiro(pleitoId, parecerFinanceiroId) {
        return axiosJwt
        .delete(`${api}/pleitos/financeiro/${pleitoId}/parecerfinanceiro/${parecerFinanceiroId}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorHandler(error)
        })
    },

    emitirAtpDirex(pleitoId) {
        return axiosJwt
            .get(`${api}/pleitos/financeiro/emitiratpdirex/${pleitoId}`, { responseType: 'blob' })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    emitirDocumentacaoJuridica(pleitoId) {
        return axiosJwt
            .get(`${api}/pleitos/financeiro/emitirdocumentacaojuridica/${pleitoId}`, { responseType: 'blob' })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    emitirPrevisaoFinanceira(pleitoId) {
        return axiosJwt
            .get(`${api}/pleitos/financeiro/emitirprevisaofinanceira/${pleitoId}`, { responseType: 'blob' })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
}
